@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="toolbar">
  <span>
    <button matButton="text" (click)="backToOrganizationDetail()">
      <span>
        <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
        <label>Back To Organization</label>
      </span>
    </button>
  </span>
  <span class="spacer"></span>
  <span>
    <button matButton="text" (click)="save()">
      <span>
        <mat-icon class="size-16">done</mat-icon>
        <label>Save</label>
      </span>
    </button>
  </span>
</div>
<div class="brandsWrapper">
  <table>
    <thead>
      <tr>
        <td class="tableCell headerCell">Currently Selected Brands</td>
      </tr>
    </thead>
    <tr>
      <td>
        <div>
          @if (checkboxes() && checkboxes().length > 0) {
            <ul>
              @for (item of checkboxes(); track item) {
                <li>
                  <mat-checkbox [(ngModel)]="item.checked">
                    {{ item.id }}
                  </mat-checkbox>
                </li>
              }
            </ul>
          }
        </div>
      </td>
    </tr>
  </table>

</div>


